<template>
    <div class="app-header-container" :class="menuOpened ? 'mq-wh100' : 'h48'">
        <div class="header-box mq-flex-between-center">
            <div class="left-box mq-flex-center">
                <img src="https://cdn.bigbays.cn/home/cangqiong-logo.png" alt="">
                <span>苍穹云系统</span>
            </div>
            <div class="right-box mq-flex-center" v-show="!headerChanged">
                <i class="icon iconfont icon-sousuo" @click="toPage('/searchM')"></i>
                <i class="icon iconfont icon-wode" @click="handleUserClick()"></i>
                <i class="icon iconfont" :class="menuOpened ? 'icon-shanchu1' : 'icon-menu'" @click="handleMenuClick()"></i>
            </div>
            <div class="right-box" v-show="headerChanged">
                <i class="icon iconfont icon-shanchu1" @click="toFromPage()"></i>
            </div>
        </div>
        <!-- menu -->
        <div class="menu-box" id="menubox">
            <div class="menu-search-box">
                <input type="text" placeholder="输入分类关键字搜索，企业应用">
                <i class="icon iconfont icon-sousuo"></i>
            </div>
            <el-menu text-color="#202344" active-text-color="#006EFF" :default-active="menuActiveIndex" :unique-opened="true" 
                @select="handleMenuSelect">
                <!-- 一级 -->
                <template v-for="(oneitem, i) in columnGoodsCateList">
                    <el-menu-item v-if="!oneitem.son || oneitem.son.length == 0" :key="i" :index="`1_${i}_${oneitem.id}`">
                        <span slot="title">{{oneitem.name}}</span>
                    </el-menu-item>
                    <el-submenu v-else :key="i" :index="`1_${i}_${oneitem.id}`" class="secondmenubox">
                        <template slot="title">{{oneitem.name}}</template>
                        <!-- 二级 -->
                        <el-menu-item :key="`${i}_${oneitem.id}`" :index="`1_${i}_${oneitem.id}`">
                            <span slot="title">
                                {{oneitem.name}}首页
                                <i class="icon iconfont icon-youjiantou"></i>
                            </span>
                        </el-menu-item>
                        <template v-for="(twoitem, j) in oneitem.son">
                            <el-menu-item v-if="!twoitem.son || twoitem.son.length == 0" :key="j" :index="`2_${i}_${j}_${twoitem.id}`">
                                <span slot="title">{{twoitem.name}}</span>
                            </el-menu-item>
                            <el-submenu v-else :key="j" :index="`2_${i}_${j}_${twoitem.id}`" class="thirdmenubox">
                                <template slot="title">{{twoitem.name}}</template>
                                <!-- 三级 -->
                                <template v-for="(threeitem, k) in twoitem.son">
                                    <el-menu-item v-if="!threeitem.son || threeitem.son.length == 0" :key="k" :index="`3_${i}_${j}_${k}_${threeitem.id}`">
                                        <span slot="title">{{threeitem.name}}</span>
                                    </el-menu-item>
                                    <el-submenu v-else :key="k" :index="`3_${i}_${j}_${k}_${threeitem.id}`" class="fourmenubox">
                                        <template slot="title">{{threeitem.name}}</template>
                                        <!-- 四级 -->
                                        <template v-for="(fouritem, l) in threeitem.son">
                                            <el-menu-item :key="l" :index="`4_${i}_${j}_${k}_${l}_${fouritem.id}`">
                                                <span slot="title">{{fouritem.name}}</span>
                                            </el-menu-item>
                                        </template>
                                    </el-submenu>
                                </template>
                            </el-submenu>
                        </template>
                    </el-submenu>
                </template>
            </el-menu>
        </div>
    </div>
</template>
<script>
export default {
    name: 'appHeader',
    data() {
        return {
            headerChanged: false, // 头部右侧操作状态是否改变
            menuList: [], // 导航菜单数据
            columnGoodsCateList: [], // 栏目商品分类数据
            menuActiveIndex: '1_0_1', // 导航菜单选中项
            menuOpened: false, // 导航菜单是否打开
            userDetail: {}, // 用户信息
        }
    },
    watch: {
        headerChanged(val) {
            this.$bus.$emit('appFooterSHow', !val);
        }
    },
    created() {
        this.getNavList();
        this.openBus();
        this.getUserData();
    },
    mounted() {
    },
    methods: {
        /**
         * @function getNavList 获取导航列表
         */
        getNavList() {
            this.$axios.get(this.$urls.columnList, {
                params: { from: 'frontend' }
            }).then(res => {
                // console.log('columnList:', res);
                let data = res.result;
                this.$store.commit('setColumnList', data);
                this.menuList = data;
                this.getPageParams();
            });
            this.$axios.get(this.$urls.columnAllCateList).then(res => {
                // console.log('columnAllCateList:', res);
                let data = res.result;
                this.columnGoodsCateList = data;
                this.$store.commit('setGoodsCateList', data);
                // this.getPageParams();
            });
        },
        /**
         * @function getPageParams 获取页面参数
         */
        getPageParams() {
            let data = window.sessionStorage.getItem('appHeader');
            let modules = [];
            if(data) {
                let _data = JSON.parse(data);
                this.menuActiveIndex = _data.nav_index;
                let idxs = String(_data.nav_index).split('_');
                if(+idxs[0] == 1) {
                    modules = this.menuList[+idxs[1]].children;
                }
            } else {
                modules = this.menuList[0].children;
            }
            this.$store.commit('setPageModuleList', modules);
        },
        /**
         * @function openBus 开启监听
         */
        openBus() {
            this.$bus.$on('navActive', res => {
                this.menuActiveIndex = res;
            });
            this.$bus.$on('headerChange', res => {
                this.headerChanged = res;
            });
            this.$bus.$on('logOut', (res) => {
                window.localStorage.setItem('token', '');
                this.userDetail = {};
                this.$store.commit('setUserDetail', this.userDetail);
            });
            this.$bus.$on('getUserData', (res) => {
                this.getUserData();
            });
        },
        /**
         * @function getUserData 获取用户信息
         */
        getUserData() {
            if(window.localStorage.getItem('token')) {
                this.$axios.get(this.$urls.userDetail).then(res => {
                    // console.log('userDetail>>>', res);
                    this.userDetail = res.result;
                    this.$store.commit('setUserDetail', this.userDetail);
                });
            }
        },
        /**
         * @function handleUserClick 用户头像点击
         */
        handleUserClick() {
            console.log(window.localStorage.getItem('token'))
            if(window.localStorage.getItem('token')) {
                // 已登录
            } else {
                // 未登录
                let oldPage = this.$route.fullPath; // 点击登录时的页面
                window.sessionStorage.setItem('historyPage', JSON.stringify({ page: oldPage }));
                this.headerChanged = true;
                this.toPage('/loginM', {});
            }
        },
        /**
         * @function handleMenuClick 导航菜单点击
         */
        handleMenuClick() {
            this.menuOpened = !this.menuOpened;
        },
        /**
         * @function handleMenuSelect 菜单选中
         */
        handleMenuSelect(key, keyPath) {
            // console.log('handleMenuSelect', key, keyPath);
            this.menuActiveIndex = key;
            let keys = String(key).split('_'), path = '', params = {};
            if(Number(keys[0]) == 1) {
                // 跳转一级页面
                let pathList = ['/homeM', '/quickSetMealM', '/strictlySelectedMallM', '/companyApplicationM', 'developerM', '/solutionM', '/policiesSupportM', '/partnerPlanM'];
                path = pathList[Number(keys[1])];
                let modules = this.menuList[Number(keys[1])].children;
                this.$store.commit('setPageModuleList', modules);
            } else {
                let id = Number(String(keyPath.pop()).split('_').pop());
                // console.log('cate_id:', id);
                if([198, 199, 200].indexOf(id) >= 0) {
                    // 政策扶持子级
                    path = '/policiesSupportM';
                    params = { policy_id: id };
                } else {
                    // 跳转到商品分类的商品列表
                    path = '/companyProductListM';
                    params = { goods_cate_id: id, index: keys[1] };
                }
            }
            // console.log('path:', path, params);
            this.toPage(path, params);
            this.menuOpened = false;
        },
        /**
         * @function toFromPage 返回 来的页面
         */
        toFromPage() {
            this.headerChanged = false;
            let data = window.sessionStorage.getItem('historyPage');
            if(data) {
                let _data = JSON.parse(data), path = _data.page;
                this.$router.push({ path: path });
            } else {
                this.$router.push({ path: '/homeM' });
            }
        },
        /**
         * @function toPage 跳转页面
         */
        toPage(path, params) {
            this.setPageParmas();
            this.$router.push({ path: path, query: params });
        },
        /**
         * @function setPageParmas 设置页面缓存参数
         */
        setPageParmas() {
            let data = {
                nav_index: this.menuActiveIndex
            };
            window.sessionStorage.setItem('appHeader', JSON.stringify(data));
        }
    }
}
</script>
<style lang="scss" scoped>
@import './AppHeader.scss';
</style>
<style lang="scss">
.app-header-container {
    .el-menu-item, .el-submenu__title {
        height: 0.5rem;
        border-bottom: 0.01rem solid #eee;
        line-height: 0.5rem;
        .icon-youjiantou {
            font-size: 0.12rem;
            color: #202344;
            transform: scale(1, .8);
        }
    }
    .el-submenu.is-active .el-submenu__title {
        border-bottom-color: #eee;
    }
    .el-menu-item.is-active {
        .icon-youjiantou {
            color: #006EFF !important;
        }
    }
    .el-menu-item:focus, .el-menu-item:hover, .el-submenu__title:hover {
        background: none;
    }
    .secondmenubox {
        > .el-menu {
            background: #FAFAFA;
        }
    }
    .thirdmenubox {
        > .el-menu {
            background: #F2F2F2;
        }
    }
    .fourmenubox {
        > .el-menu {
            background: #eee;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/common/header/AppHeader.vue